import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageDTO } from '@app/core/services/user/models/imageDTO';
import { map } from 'rxjs/operators';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '@app/core/services/util/util.service';
import { ProfileRequestStatusEnum } from '@app/core/services/profile/enum/profile-request-status.enum';
import { PagesLoadedEvent } from 'ngx-extended-pdf-viewer';
import { DocumentaryProofDCM, DocumentaryProofFile } from '@app/core/services/data-control-manager/model/documentary-proof-dcm.model';
import { DocumentaryProofDCMService } from '@app/core/services/data-control-manager/documentary-proof-dcm.service';
import { DocumentaryProofStatusEnum } from '@app/core/services/data-control-manager/model/enum/documentary-proof-status.enum';
import { NotificationService } from '@app/core/services/util/notification.service';
import { PermissionEnum } from '@app/core/services/administrator/models/enum/permission.enum';
import { UserAdminUI } from '@app/core/services/administrator/models/user-admin.model';
import { Observable } from 'rxjs';
import { AdministratorService } from '@app/core/services/administrator/administrator.service';

@Component({
  selector: 'ap-profile-request-documentary-proofs',
  templateUrl: './profile-request-documentary-proofs.component.html',
  styleUrls: ['./profile-request-documentary-proofs.component.css'],
  standalone: false
})
export class ProfileRequestDocumentaryProofsComponent implements OnInit {
  @Input() userView: boolean = false;
  @Input() documentaryProofs: DocumentaryProofDCM[] = [];
  @Input() mobilityAccountId: number;
  @Input() profileRequestStatus: ProfileRequestStatusEnum;

  @Output() openDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onChangeDocument: EventEmitter<boolean> = new EventEmitter<boolean>();

  Permissions = PermissionEnum;
  ProfileRequestStatusEnum = ProfileRequestStatusEnum;

  documentaryProofFileSelected: DocumentaryProofFile = null;
  documentPhoto: ImageDTO;
  src: any;
  documentLoaded = true;
  containsData = false;
  index: number;
  indexFile: number;

  defaultHeight = '600px';
  height = this.defaultHeight;
  loggedAgent: UserAdminUI;

  constructor(private documentaryProofDCMService: DocumentaryProofDCMService, private notificationService: NotificationService, private translateService: TranslateService, private utilService: UtilService, private administratorService: AdministratorService) {}

  ngOnInit(): void {
    this.loggedAgent = this.administratorService.loggedAgent$.getValue();
    if (this.documentaryProofs?.length > 0) {
      for (const [index, doc] of this.documentaryProofs.entries()) {
        if (doc.documentaryProofFiles?.length > 0) {
          this.selectFile({documentaryProofFileId: this.documentaryProofs[index].documentaryProofFiles[0].documentaryProofFileId, index, indexFile: 0})
          break;
        }
      }
    }
  }

  selectFile(data: any) {
    const docFileId = data?.documentaryProofFileId ? data.documentaryProofFileId : null;
    this.index = data?.index != null ? data.index : null;
    this.indexFile = data?.indexFile != null ? data.indexFile : null;
    this.height = this.defaultHeight;
    this.documentLoaded = false;
    this.containsData = false;
    if (docFileId) {
      this.documentaryProofs.forEach(dp => {
        if (dp.documentaryProofFiles.some(dpf => dpf.documentaryProofFileId === docFileId)) {
          this.documentaryProofFileSelected = dp.documentaryProofFiles.find(dpf => dpf.documentaryProofFileId === docFileId);
        }
      })
    } else {
      this.documentaryProofFileSelected = null;
      this.documentLoaded = true;
    }

    if (this.documentaryProofFileSelected && this.loggedAgent.roleInfos.permissions.includes(PermissionEnum.ACCESS_ALL_DOC_PROOF)) {
      this.documentaryProofDCMService.downloadDocumentaryProofFile(this.documentaryProofFileSelected.documentaryProofId, this.documentaryProofFileSelected.documentaryProofFileId).pipe(
        map(file => {
          const imagesData: ImageDTO = {
            imageName: `${(this.mobilityAccountId ? this.mobilityAccountId + '_' : '')}${this.documentaryProofFileSelected.documentaryProofId}_${this.documentaryProofFileSelected.documentaryProofFileId}_${moment(new Date()).format('YYYYMMDDHHmmss')}`,
            imageData: btoa(Array.from(new Uint8Array(file)).map((b) => String.fromCharCode(b)).join('')),
            imageDataDownload: file,
            extension: this.documentaryProofFileSelected.filePath.split('.').pop()
          }

          return imagesData;
        })
      ).subscribe({
        next: (image: ImageDTO) => {
          if (image) {
            this.documentLoaded = true;
            this.documentPhoto = image;
            this.containsData = !!this.documentPhoto.imageData;
            this.src = this.utilService.createUrlFromArrayBuffer(image);
          }
        }, error: err => {
          this.containsData = false;
          this.documentLoaded = true;
          this.notificationService.notify('error', this.translateService.instant('PROFILE.PROFILE_REQUEST_DETAIL.COMMON.TOAST.DOWNLOAD.ERROR'))
        }
      });
    }
  }

  onPagesLoaded(event: PagesLoadedEvent): void {
    const h = event.source.viewer.clientHeight;
    this.height = (h + 90) + 'px';
  }

  openDialogTo(value: boolean) {
    this.openDialog.emit(value);
  }

  updateEditValidateButton(documentaryProofUpdated: DocumentaryProofDCM) {
    let index = this.documentaryProofs.findIndex(doc => doc.documentaryProofId === documentaryProofUpdated.documentaryProofId);
    this.documentaryProofs[index] = documentaryProofUpdated;

    this.onChangeDocument.emit(!this.documentaryProofs.some(doc => doc.status === DocumentaryProofStatusEnum.REFUSED));
  }

  hasDocument() {
    return this.documentaryProofs.length > 0 && this.documentaryProofs.some(doc => doc.documentaryProofFiles.length > 0);
  }
}


